import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-900 relative pb-24">
      <div className="fixed inset-0 bg-gray-900 -z-10"></div>

      <Header />
      <div className="relative z-10 max-w-full mx-auto px-2 py-4">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
